var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReminder2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 14,
    viewBox: "0 0 32 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12876_58937)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 14,
    fill: "#E3A11F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11,
    width: 10,
    height: 14,
    fill: "#E3A11F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22,
    width: 10,
    height: 14,
    fill: "#F4DAA6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12876_58937"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 14,
    rx: 7,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReminder2);
export default __webpack_public_path__ + "static/media/Reminder2.5455ac2bead999062abbef4d8b994f78.svg";
export { ForwardRef as ReactComponent };